var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 32,
    fill: "#FF0000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6918 48.4097C19.1106 48.4097 18.623 48.2127 18.2292 47.8189C17.8367 47.4264 17.6405 46.9396 17.6405 46.3584C17.6405 45.7772 17.8367 45.2903 18.2292 44.8979C18.623 44.504 19.1106 44.3071 19.6918 44.3071H44.3071C44.8883 44.3071 45.3752 44.504 45.7677 44.8979C46.1615 45.2903 46.3584 45.7772 46.3584 46.3584C46.3584 46.9396 46.1615 47.4264 45.7677 47.8189C45.3752 48.2127 44.8883 48.4097 44.3071 48.4097H19.6918ZM26.9738 39.3327C26.7003 39.3327 26.4439 39.2897 26.2046 39.2035C25.9653 39.1187 25.743 38.9738 25.5379 38.7686L16.82 30.0507C16.4439 29.6746 16.2559 29.1789 16.2559 28.5635C16.2559 27.9481 16.4439 27.4524 16.82 27.0763C17.196 26.7003 17.6747 26.5122 18.2559 26.5122C18.8371 26.5122 19.3157 26.7003 19.6918 27.0763L26.9738 34.3584L44.3071 17.025C44.6832 16.649 45.1707 16.4609 45.7697 16.4609C46.3673 16.4609 46.8542 16.649 47.2302 17.025C47.6063 17.4011 47.7943 17.8879 47.7943 18.4856C47.7943 19.0845 47.6063 19.572 47.2302 19.9481L28.4097 38.7686C28.2046 38.9738 27.9824 39.1187 27.743 39.2035C27.5037 39.2897 27.2473 39.3327 26.9738 39.3327V39.3327Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTick);
export default __webpack_public_path__ + "static/media/redTick.074e0a1006ce382e14baa3703daa8d9d.svg";
export { ForwardRef as ReactComponent };